var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "single-select-dropdown" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedValue,
            expression: "selectedValue",
          },
        ],
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedValue = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            _vm.handleChange,
          ],
        },
      },
      [
        _c("option", { attrs: { disabled: "", value: "" } }, [
          _vm._v(_vm._s(_vm.placeholder)),
        ]),
        _vm._l(_vm.options, function (option) {
          return _c(
            "option",
            { key: option.value, domProps: { value: option.value } },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }